
import React from "react";
import {
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  Link,
  Image,
  List,
  ListOrdered,
  Code
} from "lucide-react";

export const insertAtCursor = (
  value: string,
  textBefore: string,
  textAfter: string = "",
  onChange: (value: string) => void
) => {
  const textarea = document.getElementById("html-editor") as HTMLTextAreaElement;
  if (!textarea) return;
  
  const startPos = textarea.selectionStart;
  const endPos = textarea.selectionEnd;
  const selectedText = value.substring(startPos, endPos);
  
  const newValue = 
    value.substring(0, startPos) + 
    textBefore + 
    selectedText + 
    textAfter + 
    value.substring(endPos);
  
  onChange(newValue);
  
  setTimeout(() => {
    textarea.focus();
    const newCursorPos = startPos + textBefore.length + selectedText.length + textAfter.length;
    textarea.setSelectionRange(newCursorPos, newCursorPos);
  }, 0);
};

export const createToolbarActions = (
  value: string,
  onChange: (value: string) => void,
  setShowImageDialog: (show: boolean) => void
) => {
  const insert = (before: string, after: string = "") => {
    insertAtCursor(value, before, after, onChange);
  };

  return [
    { 
      icon: <Bold size={18} />, 
      title: "Bold", 
      action: () => insert("<strong>", "</strong>") 
    },
    { 
      icon: <Italic size={18} />, 
      title: "Italic", 
      action: () => insert("<em>", "</em>") 
    },
    { 
      icon: <Underline size={18} />, 
      title: "Underline", 
      action: () => insert("<u>", "</u>") 
    },
    { 
      icon: <AlignLeft size={18} />, 
      title: "Align Left", 
      action: () => insert('<div style="text-align: left;">', '</div>') 
    },
    { 
      icon: <AlignCenter size={18} />, 
      title: "Align Center", 
      action: () => insert('<div style="text-align: center;">', '</div>') 
    },
    { 
      icon: <AlignRight size={18} />, 
      title: "Align Right", 
      action: () => insert('<div style="text-align: right;">', '</div>') 
    },
    { 
      icon: <Link size={18} />, 
      title: "Link", 
      action: () => insert('<a href="https://example.com">', '</a>') 
    },
    { 
      icon: <Image size={18} />, 
      title: "Image", 
      action: () => setShowImageDialog(true) 
    },
    { 
      icon: <List size={18} />, 
      title: "Bullet List", 
      action: () => insert("<ul>\n  <li>", "</li>\n</ul>") 
    },
    { 
      icon: <ListOrdered size={18} />, 
      title: "Numbered List", 
      action: () => insert("<ol>\n  <li>", "</li>\n</ol>") 
    },
    { 
      icon: <Code size={18} />, 
      title: "Code", 
      action: () => insert("<code>", "</code>") 
    },
  ];
};
